module.exports = __webpack_public_path__ + "img/simplified-residence-small.74a11eed.png";